'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var parseHtmlToReact = require('html-react-parser');
var localization = require('../localization-2ba9e8d0.js');
require('html-entities/lib/xml-entities');
require('../counted-form/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var parseHtmlToReact__default = /*#__PURE__*/_interopDefaultLegacy(parseHtmlToReact);

var LocalizationContext = react.createContext(undefined);

function useLocalization() {
  var localization = react.useContext(LocalizationContext);
  if (!localization) {
    throw new Error("Localization library is not defined in provider");
  }
  return localization;
}

// For developers this lexeme component has the following API
//     <Lexeme path="bma?abc.bcd" params={{ num: 5 }} />
// in production this will become something like
//     <Lexeme path={1} params={{ num: 5 }} />
var Lexeme = function Lexeme(_a) {
  var path = _a.path,
    params = _a.params,
    pathName = _a.pathName,
    children = _a.children;
  var localization = useLocalization();
  var text = localization.get(path, params);
  if (!text) {
    console.error("No lexeme value for ".concat(pathName, " found"));
    text = react.Children.toArray(children).join('');
  }
  if (localization.highlightLexemes) {
    return jsxRuntime.jsx("span", {
      className: "js-lexem",
      "data-js-lexem-id": pathName,
      children: parseHtmlToReact__default["default"](text)
    });
  }
  // html-react-parser helps us to avoid inline event handlers compared to dangerouslySetInnerHTML
  return jsxRuntime.jsx("span", {
    children: parseHtmlToReact__default["default"](text)
  });
};

var Localization = /** @class */function (_super) {
  localization.__extends(Localization, _super);
  function Localization(props) {
    var _this = _super.call(this, props) || this;
    _this.loc = props.instance || new localization.Localization();
    _this.setFromProps();
    return _this;
  }
  Localization.prototype.componentDidUpdate = function (prevProps) {
    if (shallowDiffers(this.props, prevProps)) {
      this.setFromProps();
      // Force re-render of context
      this.forceUpdate();
    }
  };
  Localization.prototype.setFromProps = function () {
    if (this.props.lang) {
      this.loc.setLang(this.props.lang);
    }
    if (this.props.abTests) {
      this.loc.setABTests(this.props.abTests);
    }
    if (this.props.gender) {
      this.loc.setGender(this.props.gender);
    }
    if (this.props.entries) {
      this.loc.setEntries(this.props.entries);
    }
    if (this.props.commonWords) {
      this.loc.setCommonWords(this.props.commonWords);
    }
    if (this.props.names) {
      this.loc.setNames(this.props.names);
    }
    if (this.props.cities) {
      this.loc.setCities(this.props.cities);
    }
    if (this.props.partners) {
      this.loc.setPartnerNames(this.props.partners);
    }
    if (this.props.defaultVars) {
      this.loc.setDefaultVars(this.props.defaultVars);
    }
    if (typeof this.props.showLexemeKeys === 'boolean') {
      this.loc.setShowLexemeKeys(this.props.showLexemeKeys);
    }
    if (typeof this.props.highlightLexemes === 'boolean') {
      this.loc.setHighlightLexemes(this.props.highlightLexemes);
    }
  };
  Localization.prototype.render = function () {
    return jsxRuntime.jsx(LocalizationContext.Provider, {
      value: this.loc,
      children: this.props.children
    });
  };
  return Localization;
}(react.PureComponent);
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function shallowDiffers(objA, objB) {
  for (var key in objA) {
    if (!(key in objB)) {
      return true;
    }
  }
  for (var key in objB) {
    if (objA[key] !== objB[key]) {
      return true;
    }
  }
  return false;
}

function withLocalization(Component) {
  return function WithLocalization(props) {
    var localization$1 = useLocalization();
    // @ts-ignore - ignore
    return jsxRuntime.jsx(Component, localization.__assign({
      Localization: localization$1
    }, props));
  };
}

exports.Lexeme = Lexeme;
exports.Localization = Localization;
exports.LocalizationContext = LocalizationContext;
exports.useLocalization = useLocalization;
exports.withLocalization = withLocalization;
